module.exports = __webpack_public_path__ + "static/media/pdp_squareHover.05a81be0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/pdp-hover/pdp_squareHover.jpg
// module id = 1178
// module chunks = 68